// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__R9k_m","spinning":"Spinner_spinning__ssxUu"};